import React from 'react'
import styles from './style.module.less'

export default ({ style, title, content, funs }) => {
  return (
    <div className={styles.center} style={style}>
      <div className={styles.decoration}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.tip}>{content}</p>
        {funs}
      </div>
    </div>
  )
}
